import { Card, Grid, PargodaRoundButton, styled } from '../../base';

export const ResetPasswordCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(3),
    width: '520px',
    height: '657px',
    display: 'flex',
    justifyContent: 'center',
    alignSelf: 'center',
}));

export const ResetPasswordButton = styled(PargodaRoundButton)(
    ({ theme, disabled }) => ({
        width: '210px',
        height: theme.spacing(6),
        background: disabled
            ? theme.palette.primary.light
            : `linear-gradient(180deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 86.24%)`,
    })
);

export const ResetPasswordFormWrapper = styled(Grid)(() => ({
    display: 'flex',
    justifyContent: 'center',
}));
